import { http } from '@/core/helpers/axiosHelper';
import { ApiResource } from '@/core/models/ApiResource.interface';
import { LocationQuery } from 'vue-router';
import { Customer } from '../customers/customer.interface';

export class ContractCustomerService {
   async getContractCustomers(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<Customer>>>(`/contract-customers`, { params: { ...query } });
      return response.data.data;
   }
}
